import { isEmpty as isHtmlEmpty } from '@paintscout/util/util'
import type { PresentationIsEmptyProps } from '../../'

export default function isEmpty({ section }: PresentationIsEmptyProps) {
  const fields = section?.fields
  if (!fields) {
    return true
  }

  const hasContent = fields.content && !isHtmlEmpty(fields.content)

  if (!hasContent && !fields.image) {
    return true
  }

  return false
}
